module.exports = __webpack_public_path__ + "static/media/bcsSwami.07f8cb91.webp";